import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { Button, Text } from '@/design-system';
import { cn } from '@/utils/tailwind';

export const OrgSettingsTabLink = (props: {
  to: string;
  children?: string | ReactNode;
  isIndex?: boolean;
  disabled?: boolean;
}) => {
  const location = useLocation();

  const isActive = props.isIndex
    ? location.pathname === props.to
    : location.pathname.startsWith(props.to);

  const baseClass = cn(
    'w-full border-l border-primary outline-none transition-all duration-75'
  );

  const trigger =
    typeof props.children === 'string' ? (
      <Button
        variant="plain"
        color="secondary"
        size="md"
        disabled={props.disabled}
        className="flex h-full w-full justify-start text-left"
        aria-label={props.children}
      >
        <Text weight={isActive ? 'semibold' : 'normal'}>{props.children}</Text>
      </Button>
    ) : (
      props.children
    );

  return props.disabled ? (
    <a className={cn(baseClass, 'py-2.5 text-disabled')}>{trigger}</a>
  ) : (
    <Link
      className={cn(baseClass, isActive && 'border-l-2 border-l-strong')}
      to={props.to}
    >
      {trigger}
    </Link>
  );
};
